const doshas = [
  {
    name: "Vata",
    element: "Air · Ether",
    tone: "#C05C46",
    quality: "Movement",
    body: "The subtle wind that carries thought, breath and pulse. Balance it with warmth, oil and steady routine.",
    testId: "dosha-vata",
  },
  {
    name: "Pitta",
    element: "Fire · Water",
    tone: "#E08933",
    quality: "Transformation",
    body: "The inner flame of digestion, focus and courage. Cool it with sweet, sour and softness when it flares.",
    testId: "dosha-pitta",
  },
  {
    name: "Kapha",
    element: "Earth · Water",
    tone: "#5A7A55",
    quality: "Structure",
    body: "The steady ground that offers strength, immunity and love. Awaken it with movement, warmth and spice.",
    testId: "dosha-kapha",
  },
];

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="py-20 md:py-32 bg-[#EBE4D8]/60 border-y border-[#DCD3C6]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <span className="overline">Ayurveda · The Three Doshas</span>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight">
              Every body is a
              <span className="italic text-[#C05C46]"> composition.</span>
            </h2>
          </div>
          <p className="md:col-span-5 text-lg leading-relaxed text-[#5C6B5D]">
            Ayurveda listens before it prescribes. It reads you as a unique
            weave of three forces — Vata, Pitta, Kapha — and gently returns you
            to their song.
          </p>
        </div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-12 gap-6 md:gap-8">
          {/* Bento grid */}
          <div className="md:col-span-5 md:row-span-2 relative overflow-hidden rounded-3xl border border-[#DCD3C6]">
            <img
              src="https://images.unsplash.com/photo-1492552085122-36706c238263"
              alt="Grinding herbs, mortar and pestle"
              className="h-full w-full object-cover aspect-[4/5] md:aspect-auto transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8 bg-gradient-to-t from-[#2E3A2F]/80 via-[#2E3A2F]/40 to-transparent text-[#F8F5F0]">
              <div className="overline text-[#F8F5F0]/80">Practice</div>
              <p className="mt-2 font-serif-display text-2xl md:text-3xl leading-snug">
                Every herb was once a whisper between soil and sun.
              </p>
            </div>
          </div>

          {doshas.map((d, idx) => (
            <div
              key={d.name}
              data-testid={d.testId}
              className={`md:col-span-7 bg-[#F8F5F0] border border-[#DCD3C6] rounded-3xl p-7 md:p-9 group transition-all duration-500 hover:border-[color:var(--tone)] hover:-translate-y-1 ${
                idx === 1 ? "md:col-span-4" : ""
              } ${idx === 2 ? "md:col-span-3" : ""}`}
              style={{ "--tone": d.tone }}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="overline">{d.element}</div>
                  <h3
                    className="mt-2 font-serif-display text-4xl md:text-5xl leading-none"
                    style={{ color: d.tone }}
                  >
                    {d.name}
                  </h3>
                </div>
                <span
                  className="text-xs px-3 py-1 rounded-full border"
                  style={{ borderColor: d.tone, color: d.tone }}
                >
                  {d.quality}
                </span>
              </div>
              <p className="mt-5 text-[#5C6B5D] leading-relaxed">{d.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
